export const loadingStages = [
    "Creating Original Blockcode Problem",
    "Generating Solutions",
    "Validating Solutions",
    "Building Your Blocks",
    "Completing Your Problem",
  ];
  